export default {
      id: "travel-usage",
      viewBox: "0 -960 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#travel-usage",
      toString: function () {
        return this.url;
      }
    }